import { IconFont } from '@byecode/ui'
import styled from 'styled-components'

export const TagSelectWrapper = styled.div``

export const TagSelectSearch = styled.div`
    display: flex;
    flex-wrap: wrap;
    font-size: var(--font-size-normal);
    background-color: var(--color-gray-50);
    border-bottom: 1px solid var(--color-gray-200);
    width: 100%;
    min-height: 38px;
    padding: 5px 7px;
    overflow: hidden;
`

export const TagItem = styled.div`
    position: relative;
    display: inline-flex;
    align-items: center;
    height: 24px;
    line-height: 20px;
    margin-top: 2px;
    margin-bottom: 2px;
    margin-right: 4px;
    padding: 2px 14px 2px 0;
    white-space: nowrap;
    overflow: hidden;
    color: var(--color-black);
    border: 1px solid transparent;
    &:not(.plain-container) {
        border-radius: 100px;
        padding: 0 18px 0 8px;
        /* background: #f4e7c3; */
    }
`

export const Cursor = styled.div`
    display: inline-block;
    align-items: center;
    margin-top: 3px;
    margin-bottom: 2px;
    margin-right: 4px;
    height: 22px;
    padding: 2px 4px 2px 0;
    background-color: transparent;
    /* line-height: 22px; */

    input {
        border: none;
        outline: none;
        background-color: transparent;
        color: var(--color-black);
        width: 100%;
        height: 100%;
    }
`

export const TagItemContent = styled.div`
    overflow: hidden;
    /* padding-right: 6px; */
`

export const CloseIcon = styled(IconFont)`
    position: absolute;
    right: 6px;
    top: 5px;
    font-size: 12px;
    cursor: pointer;
`
